import { Alert, Backdrop, Box, Button, CircularProgress, Paper, Snackbar, Tooltip } from "@mui/material";
import { PermissionId } from "../../../../app/permissions";
import { assertThumbnailUrl, loaded, LoadState } from "../../../../redux/common";
import { useAppDispatch } from "../../../../app/hooks";
import PossibleUsersList from "./PossibleUsersList";
import { useSelector } from "react-redux";
import { executeUsersPermissionsIns, ExecuteUsersPermissionsInsRequest, selectUsersPermissionsIns, usersPermissionsInsSlice } from "../../../../redux/user/usersPermissionsInsSlice";
import React, { useEffect, useState } from "react";
import { usersQuerySlice } from "../../../../redux/user/usersQuerySlice";
import PermissionsList from "./PermissionsList";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ModalInviteUser from "./ModalInviteUser";
import { userInviteSlice } from "../../../../redux/user/userInviteSlice";
import PrizaAvatarGrid, { PrizaAvatarGridItem } from "../../grid/PrizaAvatarGrid";
import PrizaGridBar from "../../grid/PrizaGridBar";
import PersonRemoveIcon from "@mui/icons-material/PersonRemove";
import { UserInfo } from "../../../../redux/user/userSlice";
import { RootState } from "../../../../app/store";

export interface ObjectUserAddProps {
    targetId: string;
    permissions: PermissionId[];
    back: () => void;
}
const ObjectUserAdd = (props: ObjectUserAddProps) => {
    const usersPermissionsIns = useSelector( selectUsersPermissionsIns );
    const dispatch = useAppDispatch();
    const [inviteUserOpen, setInviteUserOpen] = useState(false);
    const [usersToAdd, setUsersToAdd] = useState<UserInfo[]>([]);
    const userInvite = useSelector( (state: RootState) => state.userInvite );
    
    const [permissionsToAdd, setPermissionsToAdd] = useState<PermissionId[]>([]);
    const addPermission = (id: PermissionId) => {
        if(!permissionsToAdd.includes(id)) {
            setPermissionsToAdd( [...permissionsToAdd, id] );
        }
    };
    const removePermission = (id: PermissionId) => {
        setPermissionsToAdd( permissionsToAdd.filter( p => p !== id ) );
    };
    const statusPermission = (id: PermissionId) => {
        return permissionsToAdd.includes(id);
    };

    useEffect(() => {
        if(userInvite.state.state == LoadState.Loaded) {
            for(const newUser of userInvite.response || []) {
                if (usersToAdd.filter((user) => user.id === newUser.id).length === 0) {
                    setUsersToAdd( [...usersToAdd, newUser] );
                }
            }
            dispatch(userInviteSlice.actions.clean());
            setInviteUserOpen(false);
        }
    }, [userInvite.state.state]);

    // if(!usersPermissionsIns.request || usersPermissionsIns.request.targetId !== props.targetId) {
    //     dispatch( usersPermissionsInsSlice.actions.setTarget(props.targetId) );
    // }
    // console.debug(`Selected permissions: ${usersPermissionsIns.request?.permissionIds}`);

    const list = usersToAdd;
    const mapped: PrizaAvatarGridItem[] = list.map((item) => {
        return {
            image: assertThumbnailUrl( item.url ),
            title: item.name || item.email,
            subtitle: item.email,
            // click: () => {
            //     dispatch(usersPermissionsInsSlice.actions.remove(item));
            // },
            extra: <Tooltip title="Remover usuário da lista de adição">
                <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
                    <Button variant="outlined" size="small" color='error' onClick={() => {
                        setUsersToAdd( usersToAdd.filter( u => u.id !== item.id ) );
                    }}>
                        <PersonRemoveIcon />
                    </Button>
                </Box>
            </Tooltip>,
        };
    });

    const confirmError: React.ReactNode[] = [];
    if(permissionsToAdd.length === 0) {
        confirmError.push(<Box>Nenhuma permissão selecionada</Box>);
    }
    if(usersToAdd.length === 0) {
        confirmError.push(<Box>Nenhum usuário selecionado</Box>);
    }

    const callbackend = (event: any) => {
        event.preventDefault();
        const request: ExecuteUsersPermissionsInsRequest = {
            targetId: props.targetId,
            permissionIds: permissionsToAdd,
            users: usersToAdd,
        };
        dispatch(executeUsersPermissionsIns(request));
    };
    const back = () => {
        dispatch(usersPermissionsInsSlice.actions.clean());
        dispatch(usersQuerySlice.actions.clean());
        dispatch(usersQuerySlice.actions.setFilter(""));
        setPermissionsToAdd([]);
        setUsersToAdd([]);
        props.back();
    };

    const confirmButton = <Button onClick={callbackend} disabled={confirmError.length > 0} variant="contained" color="success">Confirmar</Button>;
    const confirmEl = confirmError.length > 0
    ? <Tooltip title={confirmError}>
        <Box> {confirmButton} </Box>
      </Tooltip>
    : confirmButton;

    const dismissSnackbar = () => { 
        dispatch(usersPermissionsInsSlice.actions.clearState());
    };
    
    const inviteUser = () => {
        dispatch(userInviteSlice.actions.clean());
        setInviteUserOpen(true);
    };

    return <Paper sx={{ width: "98%", m: "1%", pb: "1%", minWidth: "300px", backgroundColor: "#AAA" }} elevation={3}>
                <PrizaGridBar open={true} closed={false} toolbar={{
                    label: "Adicionar Usuários",
                    buttons: [
                        {
                            button: confirmEl,
                        },
                        {
                            label: "Voltar",
                            click: back
                        }
                    ],
                }}/>
        <PermissionsList 
            addPermission={addPermission}
            removePermission={removePermission}
            statusPermission={statusPermission}
            permissions={props.permissions} />
        <PrizaAvatarGrid
            list={mapped} state={loaded()}
            size='60px'
            toolbar={{ label: "Novos usuários", buttons: [
                {
                    label: <Tooltip title="Convidar novo usuário">
                            <PersonAddIcon />
                        </Tooltip>,
                    click: inviteUser
                }
            ] }}
            messages={{
                empty: "Nenhum usuário selecionado",
                error: "Erro ao carregar usuários selecionados"
            }}/>
        <PossibleUsersList 
            addUser={(user) => {
                if(!usersToAdd.find( u => u.id === user.id )) {
                    setUsersToAdd( [...usersToAdd, user] );
                }
            }}
            hasUser={(user) => {
                return usersToAdd.find( u => u.id === user.id ) ? true : false;
            }}
            inviteUser={inviteUser} />
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
             open={ usersPermissionsIns.state.state == LoadState.Loading } >
            <CircularProgress color="inherit" />
        </Backdrop>
        <Snackbar open={usersPermissionsIns.state.state == LoadState.Failed} autoHideDuration={5000} onClose={dismissSnackbar}>
            <Alert onClose={dismissSnackbar} severity="error" variant="filled" sx={{ width: "100%" }}> Erro ao adicionar permissões. </Alert>
        </Snackbar>
        <Snackbar open={usersPermissionsIns.state.state == LoadState.Loaded} autoHideDuration={5000} onClose={dismissSnackbar}>
            <Alert onClose={dismissSnackbar} severity="success" variant="filled" sx={{ width: "100%" }}> Permissões adicionadas. </Alert>
        </Snackbar>
        <ModalInviteUser open={inviteUserOpen} close={() => setInviteUserOpen(false)} />
        <Snackbar open={userInvite.state.state == LoadState.Failed} autoHideDuration={5000} onClose={() => dispatch(userInviteSlice.actions.clean())}>
            <Alert onClose={() => dispatch(userInviteSlice.actions.clean())} severity="error" variant="filled" sx={{ width: "100%" }}>
                Erro ao convidar usuário.
            </Alert>
        </Snackbar>
        {/*
    </Box>
        */}
    </Paper>;
};

export default ObjectUserAdd;